export const GET_WALK_ROUTE_REQUEST = 'GET_WALK_ROUTE_REQUEST';
export const GET_WALK_ROUTE_SUCCESS = 'GET_WALK_ROUTE_SUCCESS';
export const GET_WALK_ROUTE_FAILURE = 'GET_WALK_ROUTE_FAILURE';

export const RESET_WALK_ROUTE_DATA = 'RESET_WALK_ROUTE_DATA';
